/** Ícone/cor dos itens de menu do Hub (paridade com MenuLiderancaHelper). */

const MENU_ICON_GLYPH: Record<string, string> = {
  home: '⌂',
  'user-plus': '+',
  'book-open': '📖',
  image: '🖼',
  'clipboard-list': '📋',
  'share-2': '↗',
  newspaper: '📰',
  video: '🎬',
  calendar: '📅',
  bell: '🔔',
  target: '◎',
  users: '👥',
  'git-branch': '⑂',
  star: '★',
  trophy: '🏆',
  award: '🏅',
  'user-pen': '✎',
  'user-circle': '👤',
  'file-text': '📄',
  'clipboard-check': '☑',
  'file-check': '📜',
  lock: '🔒',
  'log-out': '↩',
}

const MENU_COLORS = new Set([
  'emerald',
  'violet',
  'blue',
  'amber',
  'rose',
  'orange',
  'indigo',
  'teal',
  'slate',
  'sky',
  'pink',
  'gray',
])

export function menuIconGlyph(icon: string | undefined): string {
  if (!icon) return '•'
  return MENU_ICON_GLYPH[icon] || '•'
}

export function menuColorClass(color: string | undefined): string {
  const c = (color || 'gray').toLowerCase()
  return MENU_COLORS.has(c) ? `bp-menu-btn--${c}` : 'bp-menu-btn--gray'
}
